<template>
  <div class="d-flex justify-content-center align-items-center">
    <div style="width: 95%">
      <router-link class="btn btn-info m-1" :to="`/dashboard/role-management`"
        >Back</router-link
      >
      <card
        class="card border"
        title="Add New Role"
        style="padding: 10px; margin-top: 8px"
      >
        <div class="form-body">
          <form @submit.prevent>
            <div>
              <label for="role">Role name</label>
              <input
                type="text"
                class="form-control border"
                id="role"
                v-model="role"
              />
            </div>

            <!-- table -->
            <div class="table-body">
              <card class="card-plain">
                <div class="table-full-width table-responsive">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr style="font-size: 13px">
                        <th scope="col">Permissions</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(permission, index) in roleAndPermissions[0]
                          .permissions"
                        :key="index"
                        class="data-row"
                      >
                        <td class="permissions-data">
                          {{ Object.keys(permission)[0].toUpperCase() }}
                        </td>
                        <td>
                          <div
                            v-for="(action, i) in Object.values(permission)[0]"
                            :key="i"
                          >
                            <label style="color: #000000">
                              <input
                                type="checkbox"
                                :value="action"
                                :id="`${Object.keys(permission)[0]}_${action}`"
                                v-model="
                                  permissionActionMap[
                                    `${Object.keys(permission)[0]}_${action}`
                                  ]
                                "
                              />
                              {{ action }}
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </card>
            </div>
            <div class="btns">
              <div class="text-center mt-4">
                <p-button
                  type="info"
                  class="btn btn-info cancel-btn"
                  @click.native.prevent="cancel"
                >
                  Cancel
                </p-button>
              </div>
              <div class="text-center mt-4">
                <p-button
                  class="btn btn-info"
                  type="submit"
                  @click.native.prevent="saveRole"
                >
                  Save
                </p-button>
              </div>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";

export default {
  data() {
    return {
      role: "",
      permissions: [],
      permissionActionMap: [],
      roleAndPermissions: [],
      newRole: [],
      error: null,
    };
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/permission`)
      .then((response) => {
        this.roleAndPermissions = response.data.roleAndPermissions;
      })
      .catch((error) => {
        this.error = error;
      });
  },
  computed: {
    //select each action for each roles
    permissionActionMap() {
      const permissionActionMap = {};
      this.roleAndPermissions[0].permissions.forEach((permission) => {
        const permissionName = Object.keys(permission)[0];
        const actions = Object.values(permission)[0];
        actions.forEach((action) => {
          const key = `${permissionName}_${action}`;
          permissionActionMap[key] = false;
        });
      });
      return permissionActionMap;
    },
  },
  methods: {
    async saveRole() {
      if (!this.role) {
        this.$confirm("Role name cannot be empty");
        return;
      }

      // Create array of selected permissions based on permissionActionMap
      const permissions = [];
      Object.keys(this.permissionActionMap).forEach((key) => {
        if (this.permissionActionMap[key]) {
          const [permission, action] = key.split("_");
          const existingPermission = permissions.find(
            (p) => p.permission === permission,
          );
          if (existingPermission) {
            existingPermission.actions.push(action);
          } else {
            permissions.push({
              permission,
              actions: [action],
            });
          }
        }
      });

      // Create object with the selected role & permissions and send request
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/role/create`,
          {
            role: this.role,
            permissions,
          },
        );
        console.log(response.data);
        this.$router.push("/dashboard/role-management");
      } catch (error) {
        console.error(error);
      }
    },
    cancel() {
      this.$confirm(
        "Are you sure you want to cancel? Changes you have made will not be saved.",
      ).then(() => {
        this.$router.push("/dashboard/role-management");
      });
    },
  },
};
</script>

<style>
.form-body {
  border: solid 1px #c1c6cb;
  border-radius: 2px;
  padding: 20px;
}
#role {
  width: 96%;
}
.table-body {
  margin-top: 15px;
}
.permissions-data {
  border-right: 1px solid #d9d9d9;
  padding-left: 10px;
  font-weight: bold;
}
.data-row {
  font-size: 15px;
  border-bottom: 1px solid #d9d9d9;
}
.btns {
  display: flex;
  gap: 20px;
  justify-content: right;
}
.cancel-btn {
  border: 2px solid #64acc2 !important;
  background-color: #fff !important;
  color: #000000 !important;
}
</style>
